import { useState, useEffect } from "react";
import api from "../api/axios";

/**
 * Hook pour récupérer toutes les pages avec leurs modules
 */
export default function usePages() {
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mounted = true;

        const fetchPagesAndModules = async () => {
            setLoading(true);
            setError(null);

            try {
                const pagesRes = await api.get("/api/web-pages");
                let pagesData = pagesRes.data || [];

                const modulesRes = await api.get("/api/modules");
                const allModules = modulesRes.data || [];

                pagesData = pagesData.map((page) => ({  //////////////////////////// associe les pages et les modules
                    ...page,
                    modules: allModules.filter(
                        (mod) => mod.web_page.id === page.id
                    ),
                }));

                if (mounted) setPages(pagesData);
            } catch (err) {
                console.error(err);
                if (mounted) setError(err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchPagesAndModules();

        return () => {
            mounted = false;
        };
    }, []);

    return { pages, loading, error };
}
